'use client';

import React from 'react';
import { Plus } from 'lucide-react';

export type AvailabilityTab = 'horarios' | 'recursos' | 'equipos' | 'bloqueos' | 'especiales';

interface AvailabilityHeaderProps {
  activeTab: AvailabilityTab;
  setActiveTab: (tab: AvailabilityTab) => void;
  onOpenNewStaff: () => void;
  onOpenNewResource?: () => void;
  onOpenNewBlock?: () => void;
}

export function AvailabilityHeader({
  activeTab,
  setActiveTab,
  onOpenNewStaff,
  onOpenNewResource,
  onOpenNewBlock
}: AvailabilityHeaderProps) {
  const tabs: { id: AvailabilityTab; label: string }[] = [
    { id: 'horarios', label: 'Horarios' },
    { id: 'recursos', label: 'Recursos' },
    { id: 'equipos', label: 'Equipos' },
    { id: 'bloqueos', label: 'Bloqueos' },
    { id: 'especiales', label: 'Especiales' },
  ];

  return (
    <div className="space-y-4">
      {/* Title */}
      <div>
        <h1 className="text-xl font-bold text-slate-900 tracking-tight">
          Horarios
        </h1>
      </div>

      {/* Tabs and Action Button Bar */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-200">
        <nav className="flex items-center gap-6 overflow-x-auto no-scrollbar -mb-px">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`py-3 text-sm font-semibold transition-colors relative whitespace-nowrap cursor-pointer ${
                  isActive
                    ? 'text-[#6255F5] font-bold border-b-2 border-[#6255F5]'
                    : 'text-slate-500 hover:text-slate-800'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>

        <div className="pb-2 sm:pb-0 shrink-0">
          {activeTab === 'horarios' && (
            <button
              type="button"
              onClick={onOpenNewStaff}
              className="flex items-center gap-1.5 px-4 py-2 bg-[#6255F5] hover:bg-[#5144E5] active:bg-[#4336D6] text-white text-xs font-semibold rounded-xl transition-all shadow-sm cursor-pointer"
            >
              <Plus className="w-4 h-4" />
              <span>+ Nuevo profesional</span>
            </button>
          )}

          {activeTab === 'recursos' && onOpenNewResource && (
            <button
              type="button"
              onClick={onOpenNewResource}
              className="flex items-center gap-1.5 px-4 py-2 bg-[#6255F5] hover:bg-[#5144E5] active:bg-[#4336D6] text-white text-xs font-semibold rounded-xl transition-all shadow-sm cursor-pointer"
            >
              <Plus className="w-4 h-4" />
              <span>+ Nuevo recurso</span>
            </button>
          )}

          {activeTab === 'bloqueos' && onOpenNewBlock && (
            <button
              type="button"
              onClick={onOpenNewBlock}
              className="flex items-center gap-1.5 px-4 py-2 bg-[#6255F5] hover:bg-[#5144E5] active:bg-[#4336D6] text-white text-xs font-semibold rounded-xl transition-all shadow-sm cursor-pointer"
            >
              <Plus className="w-4 h-4" />
              <span>+ Nuevo bloqueo</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
